/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const AuditReportsOlafMissingSpotMediaDtoTypeEnum = {
    MISSING_SPOT_MEDIA: "MISSING_SPOT_MEDIA"
} as const;

export type AuditReportsOlafMissingSpotMediaDtoTypeEnumKey = (typeof AuditReportsOlafMissingSpotMediaDtoTypeEnum)[keyof typeof AuditReportsOlafMissingSpotMediaDtoTypeEnum];

export type AuditReportsOlafMissingSpotMediaDto = {
    /**
     * @type string
    */
    type: AuditReportsOlafMissingSpotMediaDtoTypeEnumKey;
    /**
     * @type string
    */
    customId: string;
};